import './index.scss';
import '../../styles/components/_panels.scss';
